import { combineReducers, configureStore } from '@reduxjs/toolkit';
import sessionReducer from './sessionSlice.ts';
import teamReducer from './teamSlice.ts';
import userReducer from './userSlice.ts';
import fSessionReducer from './facilitatorSessionSlice.ts';
import storage from 'redux-persist/lib/storage';
import { persistReducer, persistStore } from 'redux-persist';

const persistConfig = {
    key: 'root',
    storage,
};

const rootReducer = combineReducers({
    session: sessionReducer,
    team: teamReducer,
    user: userReducer,
    fSession: fSessionReducer
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
    reducer: persistedReducer, 
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false, // Required by redux-persist
        }),
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const persistor = persistStore(store);